<template>
  <div class="ion-page">
    <ion-header class="rp-mobile">
      <ion-toolbar class="mobile-header-toolbar">
        <ion-buttons v-slot: start>
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>My Chargers</ion-title>
        <ion-buttons v-slot: end>
        <ion-button>
          <ion-icon v-slot: start name="add"></ion-icon>Add Charger
        </ion-button>
      </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-header class="rp-desktop">
      <ion-toolbar>
        <ion-buttons v-slot: start>
          <ion-menu-button></ion-menu-button>
        </ion-buttons>
        <ion-title>My Chargers</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <MyChargerHome />
    </ion-content>
  </div>   
</template>

<script>
import { defineComponent } from "vue";
import { IonHeader, IonToolbar, IonButtons, IonMenuButton, IonTitle, IonButton, IonIcon, IonContent } from "@ionic/vue";

import MyChargerHome from '@/components/customer/MyChargerHome.vue';

export default defineComponent ({
  name: 'myChargerHome',
  components: {
    IonHeader, 
    IonToolbar, 
    IonButtons, 
    IonMenuButton, 
    IonTitle, 
    IonButton, 
    IonIcon, 
    IonContent,
    MyChargerHome
  },
  data() {
    return {

    }
  },
  async mounted() {
    // console.log('discount');
  },
})
</script>

<style scoped>
ion-menu-button {
  color: #ffffff;
}
@media (max-width: 768px) {
  .mobile-header-toolbar {
    --background: #21b24b;
  }
  .mobile-header-toolbar {
    height: 56px;
    padding-top: 1px;
  }
  .mobile-header-toolbar ion-title {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-button {
    color: #ffffff;
  }
  .mobile-header-toolbar ion-back-button {
    color: #ffffff !important;
    margin-right: 13px;
  }
}
</style>